import * as React from 'react';
import { AddEmptyIcon, SubtractEmptyIcon } from '@align-cpf/uikit-icons';
import { Button } from '../../atoms/Button';
import { IInputTextProps, InputRef, InputText } from '../../atoms/InputText';
import { Icon } from '../../atoms';
import { createLocators } from '@u1/locators';
import { mergeRefs } from '../../../utils/mergeRefs';
import { validateNumberInputEvent } from './validateNumberInputEvent';
import useStyles from './InputNumber.styles';

export const inputNumberLocators = createLocators({
  name: 'InputNumber',
  componentLocators: [
    'container',
    'iconMinus',
    'iconPlus',
    'input',
    'iconContainer',
    'minusIconContainer',
    'plusIconContainer',
  ],
});
const { locators } = inputNumberLocators();

const ev = new Event('change', { bubbles: true });

const InputNumber = React.forwardRef<InputRef, IInputTextProps>(
  (props, ref) => {
    InputNumber.displayName = 'InputNumber';
    const classes = useStyles();

    const inputRef = React.useRef<InputRef>(null);

    const handleSubtract = React.useCallback(() => {
      if (inputRef.current) {
        inputRef.current.stepDown();
        inputRef.current.dispatchEvent(ev);
      }
    }, []);

    const handleAdd = React.useCallback(() => {
      if (inputRef.current) {
        inputRef.current.stepUp();
        inputRef.current.dispatchEvent(ev);
      }
    }, []);

    return (
      <div {...locators.container()} className={classes.root}>
        <InputText
          {...props}
          ref={mergeRefs([inputRef, ref])}
          type={'number'}
          onKeyDown={validateNumberInputEvent}
          onPaste={validateNumberInputEvent}
          _UNSAFE_classname={classes.inputNumber}
        />
        <div className={classes.container}>
          <Button
            {...locators.minusIconContainer()}
            className={classes.icon}
            onClick={handleSubtract}
            disabled={props.disabled}
            variant="ghost"
            size="small"
            icon={
              <Icon
                icon={SubtractEmptyIcon}
                locatorsOverrides={locators.iconMinus()}
              />
            }
          />

          <Button
            {...locators.plusIconContainer()}
            className={classes.icon}
            onClick={handleAdd}
            disabled={props.disabled}
            variant="ghost"
            size="small"
            icon={
              <Icon
                icon={AddEmptyIcon}
                locatorsOverrides={locators.iconPlus()}
              />
            }
          />
        </div>
      </div>
    );
  },
);

export default InputNumber;
